<template>
    <nav class="navbar ba-navbar" role="navigation" aria-label="main navigation">
        <div class="navbar-brand">
            <a class="navbar-item" @click.prevent="$router.push('/')">
                <img src="../assets/logo.png" alt="BestAgent logo" />
            </a>
            <div class="navbar-item"><strong>MARKETPLACE </strong><span class="tag is-warning beta-tag"> Beta </span></div>
            <a :class="{'is-active': openMenu }" @click.prevent="toggleMenu" role="button" class="navbar-burger burger">
                <span></span>
                <span></span>
                <span></span>
            </a>
        </div>

        <div id="navbarMenu" :class="{'is-active': showMenu}" class="navbar-menu">
            <div class="navbar-end">
                <div class="navbar-item">
                  <a href="https://bestagent.co.uk/blog" class="button navbar-item__button">Blog</a>
                </div>
                <div class="navbar-item">
                  <a href="#" @click.prevent="$router.push('/faqs')" class="button navbar-item__button">FAQ's</a>
                </div>
                <div class="navbar-item">
                  <a href="#" @click.prevent="$router.push('/account')" class="button navbar-item__button">My Account</a>
                </div>
                <div class="navbar-item">
                  <a href="#" @click.prevent="handleLogout" class="btn-logout has-text-white is-uppercase">
                    Logout
                  </a>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
import { logout } from '../libs/AuthService';

export default {
  name: 'Navbar',
  data: function() {
		return {
			showMenu: false,
			openMenu: false
		}
	},
  methods: {
    handleLogout() {
      logout();
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
			this.openMenu = !this.openMenu;
    }
  },
};
</script>

<style lang="scss">
.ba-navbar.navbar {

  .navbar-item, .navbar-item strong {
    color: white;
  }

  .navbar-item img {
    max-height: 45px;
  }

  .btn-logout {
    cursor: pointer;
  }
}
</style>
